/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Weekend_DescInputs */



/**
* | output |
* | --- |
* | "Add the weekend to the week view of your agenda." |
*
* @param {Settings_Weekend_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_weekend_desc = /** @type {((inputs?: Settings_Weekend_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Weekend_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voeg het weekend toe aan de weekweergave van je agenda.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le week-end apparaît aussi dans la vue semaine de votre agenda.")
	return /** @type {LocalizedString} */ ("Add the weekend to the week view of your agenda.")
});